<template>
    <div class="box-con">
        <div class="build-bar">
            <el-col :span="12" style="text-align: left;padding-left: 20px;display: flex;">
                <span style="display: flex;align-items: center;">名称：</span>
                <el-input
                  v-model="name"
                  placeholder="请输入名称"
                  clearable
                >
                    <el-button slot="append" icon="el-icon-search" @click="doFilter"></el-button>
                </el-input>
            </el-col>
        </div>
        <div class="build-table">
            <el-table :data="tableData" height="calc( 100% - 6vh )" style="width: 100%">
                <template slot="empty">
                    <p>{{dataText}}</p>
                </template>
                <el-table-column label="序号" width="100">
                    <template slot-scope="scope">
                    <span>{{ scope.row.index }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="设备名称">
                    <template slot-scope="scope">
                        <span>{{scope.row.channelName}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="序列号">
                    <template slot-scope="scope">
                    <span>{{ scope.row.sid }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="所属项目">
                    <template slot-scope="scope">
                    <span>{{ scope.row.projectName }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="时间" width="300">
                    <template slot-scope="scope">
                    <span>{{ scope.row.createDate }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="200">
                    <template slot-scope="scope">
                        <el-button size="mini" type="primary" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <!-- 分页展示 -->
            <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[3, 5, 10, 20]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalItems"
            ></el-pagination>
        </div>
        <!--  -->
        <el-dialog
            title="设备编辑"
            :visible.sync="devVis"
            center
            :append-to-body="true"
            :lock-scroll="false"
            class="add-form"
            width="500px"
       >
          <el-form ref="form" :model="form" label-width="80px">
            <el-form-item label="设备名称">
                <el-input v-model="form.channelName"></el-input>
            </el-form-item>
            <el-form-item label="所属设备">
                <el-select v-model="form.projectId" filterable placeholder="请选择项目">
                    <el-option v-for="(item,index) in groups" :key="index" :label="item.groupName" :value="item.groupId"></el-option>
                </el-select>
            </el-form-item>
            <div style="width:100%;height:8vh;display:flex;justify-content: center;align-content: center;align-items: center;">
                <el-button type="primary" @click="modSubmit" round style="width:80%;">确定提交</el-button>
            </div>
          </el-form>
      </el-dialog>
    </div>
</template>

<script>
import myHttp from '../../../untils/port'
import util from '../../../untils/util'
export default {
    data(){
        return{
            name:'',
            tableData:[],
            groupId:'',
            dataText:'数据加载中...',
            currentPage:1,
            pageSize:10,
            totalItems:0,
            devVis:false,
            form:{
                channelName:'',
                projectId:''
            },
            groups:[],//
        }
    },
    mounted(){
        this.groupId = util.session.get('groupId')
        this.getData()
    },
    methods:{
        //查询
        doFilter(){

        },
        handleSizeChange(val){
            this.pageSize = val
            this.handleCurrentChange(this.currentPage)
        },
        handleCurrentChange(val){
            this.currentPage = val
            this.currentChangePage();
        },
        currentChangePage() {
            this.getData();
        },
        //获取数据
        getData(){
            var that = this
            myHttp.selectAllAiCameraPage({
                pageNum:this.currentPage,
                pageSize:this.pageSize,
                name:this.name
            }).then(function(resp){
                console.log(resp)
                if(resp.data.code=='200'){
                    var list = resp.data.data.aiEquipCameras.list||[]
                    for(var i=0;i<list.length;i++){
                        list[i].index = (that.currentPage - 1) * that.pageSize + (i + 1)
                    }
                    that.tableData = list
                    that.totalItems = resp.data.data.aiEquipCameras.total||0
                    if(list.length==0){
                        that.dataText = '暂无数据'
                    }
                }else{
                    that.dataText = '暂无数据'
                }
            })
        },
        //编辑
        handleEdit(index,row){
            this.devVis = true
            this.form.id = row.id
            this.form.channelName = row.channelName
            
            var that = this
            myHttp.getGroupListByUsePlat({
                userType:4
            }).then(function(resp){
                if(resp.data.code=='200'){
                    var list = resp.data.data.list||[]
                    that.groups = list;
                    setTimeout(function(){
                        that.form.projectId = row.projectId
                    },10)
                }
            })
        },
        //编辑条件
        modSubmit(){
            var that = this
            myHttp.updateAiEquipCamera(this.form).then(function(resp){
                if(resp.data.code=='200'){
                    that.getData();
                    that.$message.success('编辑成功');
                    that.devVis = false
                }else{
                    that.$message.error(resp.data.msg);
                }
            })
        },

    },
}
</script>

<style scoped>
    .box-con{
        width:100%;
        height: 100%;
        position: relative;
        padding: 1vh;
        background: #fff;
    }
    .build-bar{
        width: 100%;
        height: 6vh;
        position: relative;
        display: flex;
        justify-content: flex-start;
        align-content: center;
        align-items: center;
        border-bottom: 2px solid #0490F9;
    }
    .build-table{
        width: 100%;
        height: calc( 100% - 6vh );
        position: relative;
    }
</style>

<style>

</style>